export default __webpack_public_path__ + "static/DSC_6587-1d3d4348344987c9d1788052201c4e38.jpg";